import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";

const TITLE = "Calculatrice de Différence d'Âge - Calculez la différence d'âge entre deux personnes";
const DESCRIPTION =
  "Calculatrice de Différence d pour calculer des dates, durees ou ages avec precision. Outil pratique pour vos demarches administratives, votre organisation personnelle et vos besoins du quotidien.";
const KEYWORDS =
  "de différence d, calculatrice de différence d, calcul en ligne, age, date, temps, calendrier, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/gregoriandifferences/";

const GREGORIAN_MONTHS = [
  "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
  "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"
];

function AgeCalculatorGregorian() {
  const [d1, setD1] = useState({ day: "1", month: "1", year: "1990" });
  const [d2, setD2] = useState({ day: new Date().getDate().toString(), month: (new Date().getMonth() + 1).toString(), year: new Date().getFullYear().toString() });
  const [differences, setDifferences] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const calculateDifferences = () => {
    setIsLoading(true);
    const date1 = new Date(parseInt(d1.year), parseInt(d1.month) - 1, parseInt(d1.day));
    const date2 = new Date(parseInt(d2.year), parseInt(d2.month) - 1, parseInt(d2.day));

    if (isNaN(date1.getTime()) || isNaN(date2.getTime())) {
      setError("Veuillez entrer des dates valides");
      setDifferences(null);
      setIsLoading(false);
      return;
    }

    let startDate = date1 < date2 ? date1 : date2;
    let endDate = date1 < date2 ? date2 : date1;

    let years = endDate.getFullYear() - startDate.getFullYear();
    let months = endDate.getMonth() - startDate.getMonth();
    let days = endDate.getDate() - startDate.getDate();

    if (days < 0) {
      months--;
      const lastMonth = new Date(endDate.getFullYear(), endDate.getMonth(), 0);
      days += lastMonth.getDate();
    }
    if (months < 0) {
      years--;
      months += 12;
    }

    const totalMilliseconds = endDate - startDate;
    const totalSeconds = Math.floor(totalMilliseconds / 1000);
    const totalMinutes = Math.floor(totalSeconds / 60);
    const totalHours = Math.floor(totalMinutes / 60);
    const totalDays = Math.floor(totalHours / 24);

    setDifferences({
      years, months, days,
      totalDays,
      totalWeeks: Math.floor(totalDays / 7),
      totalMonths: years * 12 + months,
      totalHours,
      totalMinutes,
      totalSeconds,
      startDateStr: startDate.toLocaleDateString("fr-FR", { weekday: "long", year: "numeric", month: "long", day: "numeric" }),
      endDateStr: endDate.toLocaleDateString("fr-FR", { weekday: "long", year: "numeric", month: "long", day: "numeric" }),
      centuryPercentage: ((totalDays / (100 * 365.25)) * 100).toFixed(2),
      solarYears: (totalDays / 365.25).toFixed(2),
      workDays: Math.floor((totalDays / 7) * 5),
    });
    setError(null);
    setIsLoading(false);
  };

  const renderSelectDate = (data, setData, label) => (
    <div className="mb-4">
      <label ><strong>{label}:</strong></label>
      <div className="row">
        <div className="col-md-4">
          <select className="form-control" value={data.day} onChange={(e) => setData({ ...data, day: e.target.value })}>
            {Array.from({ length: 31 }, (_, i) => i + 1).map(d => <option key={d} value={d}>{d}</option>)}
          </select>
        </div>
        <div className="col-md-4">
          <select className="form-control" value={data.month} onChange={(e) => setData({ ...data, month: e.target.value })}>
            {GREGORIAN_MONTHS.map((m, i) => <option key={i + 1} value={i + 1}>{i + 1} - {m}</option>)}
          </select>
        </div>
        <div className="col-md-4">
          <select className="form-control" value={data.year} onChange={(e) => setData({ ...data, year: e.target.value })}>
            {Array.from({ length: 150 }, (_, i) => new Date().getFullYear() + 10 - i).map(y => <option key={y} value={y}>{y}</option>)}
          </select>
        </div>
      </div>
    </div>
  );

  return (
    <div style={{ direction: "ltr" }}>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center p-3">
            <h1 style={{ fontSize: "20px", margin: 0 }}>{TITLE}</h1>
          </div>
          <div className="border border-light p-3">
            <p>
              Cette calculatrice vous permet de calculer la différence d'âge entre deux personnes. Entrez les deux dates de naissance et la calculatrice affichera la différence en années, mois, jours et autres unités de temps.
            </p>
            <hr />
            <MobileUnderCalAds />

            <div className="calculatorStyle p-3 bg-light rounded">
              {renderSelectDate(d1, setD1, "Première date")}
              {renderSelectDate(d2, setD2, "Deuxième date")}

              <div className="text-center mb-4">
                <button className="btn btn-success btn-lg px-5" onClick={calculateDifferences} disabled={isLoading}>
                  {isLoading ? "Calcul en cours..." : "Calculer la Différence"}
                </button>
              </div>

              {error && <div className="alert alert-danger">{error}</div>}

              {differences && (
                <div className="alert alert-success mt-4">
                  <h3>Résultats:</h3>
                  <div className="mb-3">
                    <strong style={{ fontSize: "24px", color: "#28a745" }}>
                      Différence: {differences.years} ans, {differences.months} mois et {differences.days} jours
                    </strong>
                  </div>
                  <div className="mt-3">
                    <p><strong>Détails complets:</strong></p>
                    <ul>
                      <li><strong>Date de début:</strong> {differences.startDateStr}</li>
                      <li><strong>Date de fin:</strong> {differences.endDateStr}</li>
                      <li><strong>Jours totaux:</strong> {differences.totalDays}</li>
                      <li><strong>Semaines totales:</strong> {differences.totalWeeks}</li>
                      <li><strong>Mois totaux:</strong> {differences.totalMonths}</li>
                      <li><strong>Heures totales:</strong> {differences.totalHours}</li>
                      <li><strong>Minutes totales:</strong> {differences.totalMinutes}</li>
                      <li><strong>Secondes totales:</strong> {differences.totalSeconds}</li>
                      <li><strong>Années solaires:</strong> {differences.solarYears}</li>
                      <li><strong>Jours de travail (5 jours/semaine):</strong> {differences.workDays}</li>
                      <li><strong>Pourcentage du siècle:</strong> {differences.centuryPercentage}%</li>
                    </ul>
                  </div>
                </div>
              )}
            </div>
          </div>
          <br />
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
          <RelatedLinks />
          <br />
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Différence d’âge entre deux personnes</h3></div>
              <div className="info-section-body">
                <p>La différence d’âge entre deux personnes se calcule en soustrayant la date de naissance la plus récente de la plus ancienne. Cette calculatrice vous donne la différence précise en années, mois et jours — utile pour comparer l’âge de membres d’une famille, de collègues ou de jumeaux nés à quelques minutes d’intervalle.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Pourquoi calculer la différence d’âge ?</h3></div>
              <div className="info-section-body">
                <p>Connaître la différence d’âge entre deux personnes est utile dans de nombreux contextes : pour les écoles (vérifier l’intervalle entre frères et sœurs), en médecine (calcul d’une différence générationnelle), ou simplement par curiosité. En France, l’âge légal pour certains actes (vote, mariage, retraite) rend ce calcul pratiquement utile.</p>
              </div>
            </div>            <div className="info-section">
              <div className="info-section-header">Questions fréquentes</div>
              <div className="info-section-body">
                <h3 style={{ fontSize: "16px" }}><strong>Comment calcule-t-on la différence d'âge entre deux personnes ?</strong></h3>
                <p>On soustrait la date de naissance la plus récente de la plus ancienne. La calculatrice détermine la différence précise en années, mois et jours en tenant compte des longueurs de mois variables et des années bissextiles.</p>
                <hr />
                <h3 style={{ fontSize: "16px" }}><strong>Pourquoi la différence d'âge n'est pas toujours un nombre entier d'années ?</strong></h3>
                <p>Parce que les deux personnes n'ont pas nécessairement leur anniversaire le même jour. La calculatrice affiche la différence exacte incluant les mois et jours résiduels entre les deux dates.</p>
                <hr />
                <h3 style={{ fontSize: "16px" }}><strong>Peut-on calculer la différence entre des dates futures ?</strong></h3>
                <p>Oui, la calculatrice accepte n'importe quelle date valide, passée ou future. Vous pouvez par exemple calculer la différence d'âge entre deux personnes à une date future spécifique.</p>
                <hr />
                <h3 style={{ fontSize: "16px" }}><strong>La calculatrice fonctionne-t-elle avec des jumeaux ?</strong></h3>
                <p>Oui, même pour des jumeaux nés à quelques minutes d'intervalle, vous pouvez entrer les dates et heures exactes pour obtenir la différence précise en minutes.</p>
              </div>
            </div>          </div>
        </div>
      </div>
    </div>
  );
}

export default AgeCalculatorGregorian;
